import React, { useState, useEffect } from 'react';
import '../styles/Modal.css';

function CustomerModal({ customer, onSave, onClose }) {
  const [formData, setFormData] = useState({
    customerType: 'Individual',
    fullName: '',
    companyName: '',
    phoneNumber: '',
    emailId: '',
    street: '',
    area: '',
    city: '',
    state: '',
    pincode: '',
    gstinNumber: '',
    stateCode: '',
    gstRegistered: false,
  });

  useEffect(() => {
    if (customer) {
      setFormData(customer);
    }
  }, [customer]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.fullName || !formData.phoneNumber) {
      alert('Please fill in all required fields');
      return;
    }
    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>{customer ? 'Edit Customer' : 'Add New Customer'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Customer Type *</label>
              <select
                name="customerType"
                value={formData.customerType}
                onChange={handleChange}
              >
                <option value="Individual">Individual</option>
                <option value="Business">Business</option>
              </select>
            </div>

            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {formData.customerType === 'Business' && (
            <div className="form-group">
              <label>Company Name *</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Phone Number *</label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email ID</label>
              <input
                type="email"
                name="emailId"
                value={formData.emailId}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Street</label>
              <input
                type="text"
                name="street"
                value={formData.street}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Area</label>
              <input
                type="text"
                name="area"
                value={formData.area}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Pincode</label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>GSTIN Number</label>
              <input
                type="text"
                name="gstinNumber"
                value={formData.gstinNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>State Code</label>
              <input
                type="text"
                name="stateCode"
                value={formData.stateCode}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group checkbox">
            <input
              type="checkbox"
              id="gstRegistered"
              name="gstRegistered"
              checked={formData.gstRegistered}
              onChange={handleChange}
            />
            <label htmlFor="gstRegistered">GST Registered</label>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {customer ? 'Update' : 'Create'} Customer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CustomerModal;
